<!---67 RemoveDeadReferences-->
<div class="dx-field">
  <div class="dx-field-label w-50">{{ 'Selbstreferenzen löschen' }}</div>
  <dx-switch [(value)]="removeSelfReferencing"></dx-switch>
</div>

